import { SVGRenderer } from '../core/SVGRenderer';
import { ConstructionStep } from '../types';
import { Compass } from '../objects/Compass';
import { Ruler } from '../objects/Ruler';

export abstract class BaseConstruction {
  protected renderer: SVGRenderer;
  protected compass: Compass;
  protected ruler: Ruler;

  constructor(renderer: SVGRenderer, compass: Compass, ruler: Ruler) {
    this.renderer = renderer;
    this.compass = compass;
    this.ruler = ruler;
  }

  public abstract buildSteps(options?: any): ConstructionStep[];
}
